import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-sos-service-row',
    templateUrl: './sos-service-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class SosServiceRowComponent extends BaseRow{
}
